import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireAnimateOnScroll } from "/Users/yvonne/Repositories/2. H1/Shopify-reisartikelen/theme/assets/animate-on-scroll.js";
var animateOnScrollExports = requireAnimateOnScroll();
export { animateOnScrollExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(animateOnScrollExports);